import React, { ChangeEvent, memo } from 'react';
import { useTranslation } from 'i18n';
import { TFunction } from 'next-i18next';

import { caseOptions, dateCases, parseDateFilterValue } from 'components/filters/dateFilters';
import FilterSelectHandler from './FilterSelectHandler';
import { slugValueFormatter, titleLabelFormatter } from './utils';

export interface IDatesFilterProps {
  disabled?: boolean;
  multiple?: boolean;
}

const valueTransformer = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
  const caseOption = caseOptions[value as keyof typeof caseOptions];

  if (caseOption) return caseOption();
};

const valueParser = (queryParams: Record<string, string | string[]>) => {
  const { start_at__date__gte, start_at__date__lte } = queryParams;

  if (start_at__date__gte && start_at__date__lte) {
    return parseDateFilterValue(start_at__date__gte, start_at__date__lte);
  }
};

const getDateItems = (t: TFunction) =>
  dateCases.map((value) => ({
    slug: value,
    title: t('common:filter.eventDate', { context: value }),
  }));

const clearValueParser: () => { [key: string]: undefined } = () => ({
  start_at__date__gte: undefined,
  start_at__date__lte: undefined,
});

const DateFilter: React.FC<React.PropsWithChildren<IDatesFilterProps>> = (props) => {
  const { disabled, multiple } = props;

  const [t] = useTranslation();

  return (
    <FilterSelectHandler
      multiple={multiple}
      name="date"
      placeholder={t<string>('common:filter.date')}
      disabled={disabled}
      items={getDateItems(t)}
      labelFormatter={titleLabelFormatter}
      valueFormatter={slugValueFormatter}
      valueTransformer={valueTransformer}
      valueParser={valueParser}
      clearValueParser={clearValueParser}
    />
  );
};

export default memo(DateFilter);
